import {ChangeDetectorRef, Component, QueryList, ViewChildren} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams, Select} from 'ionic-angular';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { ReportEditPartPage } from "../report-edit-part/report-edit-part";
import { ReportAddPartPage } from "../report-add-part/report-add-part";
import { ReportEditRepairPage } from "../report-edit-repair/report-edit-repair";
import { ReportAddRepairPage } from "../report-add-repair/report-add-repair";
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { ReportService } from "../../services/report.service";
import { ApiService } from "../../services/api.service";
import { Camera } from "@ionic-native/camera";
import { ViewPhotoPage } from "../view-photo/view-photo";

@Component({
  selector: 'page-report-repairs',
  templateUrl: 'report-repairs.html',
})
export class ReportRepairsPage {

  @ViewChildren(Select) ionSelects: QueryList<Select>;

  data: any;
  submitAttempt = false;
  enabled = false;
  reportForm: FormGroup;
  showFooter = false;
  hasProSubscription = false;
  unitType = 1;
  workorderType = 1;
  country = 'NL';

  repairs = [];
  parts = [];
  photos = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public superTabsCtrl: SuperTabsController,
    public apiService: ApiService,
    public camera: Camera,
    public changeDetector: ChangeDetectorRef,
    public alertCtrl: AlertController,
    public reportService: ReportService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    console.log(this.data);
    if(this.data.repairs) this.repairs = this.data.repairs;
    if(this.data.parts) this.parts = this.data.parts;
    if(this.data.photos) this.photos = this.data.photos;
    this.enabled = false;
    // Get unittype
    if(this.data._selected_units && this.data._selected_units[0]) {
      this.unitType = parseInt(this.data._selected_units[0].unit_model_unit_type);
      this.enabled = true;
    }
    // Get workorderType
    this.workorderType = parseInt(this.data.workorder_type);
    // Set hasProSubscription
    this.hasProSubscription = this.apiService.hasProSubscription(this.unitType);
    // Set country
    if (this.data.customers.client && this.data.customers.client.country) {
      this.country = this.data.customers.client.country;
    }
    // Init form
    this.reportForm = this.formBuilder.group({
      is_unit_ok: ['', Validators.required],
      is_unit_safe: ['', Validators.required],
      revisit: ['Nee'],
      not_fixed: [''],
      not_fixed_rogafa1: [false],
      not_fixed_rogafa2: [false],
      not_fixed_dyn_druk: [false],
      not_fixed_dichtheidsbeproeving_gasleiding: [false],
      not_fixed_drukveiligheid_gemonteerd: [false],
      not_fixed_expansievat_foutief_gemonteerd: [false],
      bbs_co_te_hoog_opstellingsruimte: [false],
      bbs_co_te_hoog_rookgassen: [false],
      bbs_niet_correct_gemonteerde_rookgasafvoer: [false],
      bbs_niet_correct_gemonteerde_lucht_afvoer: [false],
      bbs_overige_reden: [''],
      bbs_reden_onveiligheid: [''],
      bbs_advies: [''],
      minutes_worked: [''],
      notes: ['']
    });
    this.reportForm.patchValue(this.data);
  }

  ionViewDidEnter() {
    console.log('ReportRepairsPage: ionViewDidEnter');
    this.initForm();
    if (this.ionSelects) this.ionSelects.map((select) => select._inputUpdated());
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportRepairsPage: ionViewDidLeave');
    this.save();
  }

  isValid(){
    if(!this.hasProSubscription){
      return true;
    }
    if(this.reportForm.valid){
      return true;
    }
    return false;
  }

  save(){
    this.reportForm.markAsTouched();
    if(this.isValid()){
      this.superTabsCtrl.setColor('reportRepairsPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportRepairsPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportRepairsPage', 'tab_error', 'mainTabs');
      this.data._valid.reportRepairsPage = -1;
    }
    let values = this.reportForm.value;
    this.data.minutes_worked = values.minutes_worked;
    Object.assign(this.data, this.reportForm.value);
    Object.assign(this.data, {
      repairs: this.repairs,
      parts: this.parts,
      photos: this.photos
    });
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportSubmitPage', 'mainTabs');
    });
  }

  addPart(){
    this.modalCtrl.create(ReportAddPartPage, {
      items: this.parts
    }).present();
  }

  editPart(item, index){
    this.modalCtrl.create(ReportEditPartPage, {
      index: index,
      items: this.parts,
      item: item
    }).present();
  }

  addRepair(){
    this.modalCtrl.create(ReportAddRepairPage, {
      items: this.repairs
    }).present();
  }

  editRepair(item, index){
    this.modalCtrl.create(ReportEditRepairPage, {
      index: index,
      items: this.repairs,
      item: item
    }).present();
  }

  addPhoto(){
    this.alertCtrl.create({
      title: 'Foto toevoegen',
      cssClass: 'alert-not-bold',
      buttons: [
        {
          text: 'Nieuwe foto maken',
          handler: () => {
            this.getPicture(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: 'Kies foto uit fotoalbum',
          handler: () => {
            this.getPicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        }
      ]
    }).present();
  }

  getPicture(sourceType){
    this.camera.getPicture({
      quality: 60,
      targetWidth: 1200,
      targetHeight: 1200,
      correctOrientation: true,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }).then((imageData) => {
      let src = 'data:image/jpeg;base64,' + imageData;
      this.photos.push({
        src: src
      });
      this.uploadPhotos();
    }, (err) => {
      this.changeDetector.detectChanges();
    });
  }

  viewPhoto(photo, index){
    this.modalCtrl.create(ViewPhotoPage, {
      photo: photo,
      photos: this.photos,
      index: index
    }, {
      cssClass: 'modal-fullscreen'
    }).present();
  }

  getPhotosCount(){
    let photosCount = 0;
    for (let p of this.photos) {
      if (!p._deleted) {
        photosCount++;
      }
    }
    return photosCount;
  }

  uploadPhotos() {
    for (let photo of this.photos) {
      if (!photo.file_id) {
        this.apiService.uploadPhoto(photo.src).then((data: any) => {
          photo.file_id = data.file_id;
          photo.token = data.token;
          photo.src = data.display_url;
          photo._new_file = true;
        }).catch((error) => {
          console.error(error);
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-repairs/report-repairs.ts